import { createContext, useContext, useEffect, ReactNode } from 'react';
import { useLocation } from 'react-router-dom';
import { initPostHog, posthog } from '@/lib/posthog';
import { useAuth } from '@/hooks/useAuth';

const PostHogContext = createContext(posthog);

export const usePostHog = () => useContext(PostHogContext);

export const PostHogProvider = ({ children }: { children: ReactNode }) => {
  const location = useLocation();
  const { user } = useAuth();

  useEffect(() => {
    initPostHog();
  }, []);

  // Track page views
  useEffect(() => {
    posthog.capture('$pageview', {
      $current_url: window.location.href,
    });
  }, [location]);

  // Identify user
  useEffect(() => {
    if (user) {
      posthog.identify(user.id, {
        email: user.email,
      });
    } else {
      posthog.reset();
    }
  }, [user]);

  return (
    <PostHogContext.Provider value={posthog}>
      {children}
    </PostHogContext.Provider>
  );
};
